import colors from 'shared/colors';
import { optionColor } from 'shared/constants.json';
import { rgbaToHex } from 'shared/lib/color';

export const getColor = (color) => {
  switch (color) {
    case optionColor.grey:
      return rgbaToHex(colors.grey.lighten3);
    case optionColor.brown:
      return colors.brown.lighten3;
    case optionColor.orange:
      return colors.orange.lighten3;
    case optionColor.yellow:
      return colors.yellow.lighten3;
    case optionColor.green:
      return colors.green.lighten3;
    case optionColor.blue:
      return colors.blue.lighten2;
    case optionColor.purple:
      return colors.purple.lighten3;
    case optionColor.pink:
      return colors.pink.lighten3;
    case optionColor.red:
      return colors.red.lighten3;
    default:
      return rgbaToHex(colors.grey.lighten3);
  }
};
